module.exports = __webpack_public_path__ + "static/media/joseph100.80e863e1.jpg";